export const HotelAssetClassTypeID = 20;